import React, { useState, useEffect } from "react";
import { Editor } from "react-draft-wysiwyg";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "draft-js/dist/Draft.css";
import draftToHtml from "draftjs-to-html";
import DOMPurify from "dompurify";
import htmlToDraft from "html-to-draftjs";
import { FormControl, FormHelperText, InputLabel, Typography } from '@mui/material';
import { useInput } from 'react-admin';

export default function HTMLInput({ source, validate, ...props }) {
  const [editorState, setEditorState] = useState(EditorState.createEmpty())
  const { field, fieldState } = useInput({
    source,
    validate,
    defaultValue: props.content
  })
  const { error } = fieldState

  useEffect(() => {
    const content = field.value
    if (content !== null && content !== undefined) {
      let editor = null;

      if (content) {
        const contentBlock = htmlToDraft(content);
        if (contentBlock) {
          const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
          editor = EditorState.createWithContent(contentState);
        }
      } else {
        editor = EditorState.createEmpty();
      }

      setEditorState(editor);
      handleChange(editor);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleChange = (value) => {
    setEditorState(value);

    const text = draftToHtml(convertToRaw(value.getCurrentContent()))
    field.onChange(text)
    props.onChange && props.onChange(text);
  }

  const createMarkup = (html) => {
    const htmlConverted = draftToHtml(convertToRaw(html.getCurrentContent()))
    return {
      __html: DOMPurify.sanitize(htmlConverted)
    }
  }

  return (
    <>
      {props.readOnly ? (
        <div>
          <Typography
            className='html-label'
            component="h4"
            variant="body1"
          >
            {props.label}
          </Typography>
          <div dangerouslySetInnerHTML={createMarkup(editorState)} />
        </div>
      )
      :
      (
        <FormControl fullWidth style={{ marginTop: 25 }} className='html-form-control'>
          <InputLabel id={props.labelId} className='html-label'>{props.label}</InputLabel>
          <Editor
            editorState={editorState}
            onEditorStateChange={handleChange}
            wrapperClassName="html-wrapper-class"
            editorClassName={`html-editor-class ${props.disabled ? "disabled" : ""}`}
            toolbarClassName="html-toolbar-class"
            readOnly={props.disabled}
          />
          <FormHelperText error={Boolean(error?.message) || props.error}>
            {error?.message || props.errorText}&nbsp;
          </FormHelperText>
        </FormControl>
      )}
    </>
  )
}
